import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageService } from '../../services/language.service';
/**
 * Subscribe Unregistered Component
 */
let SubscribeUnregisteredComponent = class SubscribeUnregisteredComponent {
    constructor(httpClient, sanitizer, themeService, router, route, languageService) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.router = router;
        this.route = route;
        this.languageService = languageService;
        this.backColor = '';
        this.accentColor = '';
        this.mainColor = '';
        this.borderRadiusLarger = '';
        this.borderRadiusSmaller = '';
        this.textColor = '';
        this.errorColor = '';
        this.successColor = '';
        this.linkColor = '';
        this.inputBackColor = '';
        this.errorMessage = '';
        this.newsletterHash = '';
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
    }
    ngOnInit() {
        this.route.params.subscribe((params) => {
            this.newsletterHash = params['hash'];
        });
        const data = { hash: this.newsletterHash };
        this.httpClient.post('newsletter/subscribeunregistered', data).subscribe((data) => {
            if (!data) {
                this.router.navigateByUrl('');
            }
        });
    }
};
SubscribeUnregisteredComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: Router },
    { type: ActivatedRoute },
    { type: LanguageService }
];
SubscribeUnregisteredComponent = __decorate([
    Component({
        selector: 'ecd-subscribe-unregistered',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./subscribe-unregistered.component.html")).default
    })
], SubscribeUnregisteredComponent);
export { SubscribeUnregisteredComponent };
